module.exports = __webpack_public_path__ + "static/media/ic_01_firewall.1e2def9d.svg";